<template>
    <div style="padding:20px 10px 20px 0px; background-color:#f5f7fa">
        <div style="position:relative; height:100%; width:100%;">
            <div style="position:absolute; z-index: 9999; left:20px; top:20px;">
                <!--<div>필터</div>-->
            </div>
            <div style="position:absolute; z-index: 9999; right:20px; top:20px;">

            </div>
            <div style="display:flex; width:100%; height:100%;">
                <div style="width:400px; ">
                    <table class="tb" style="background-color: white;">
                        <colgroup>
                            <col width="100px"/>
                            <col width="80px"/>
                            <col width="80px"/>
                            <col width="80px"/>
                            <col />
                        </colgroup>
                        <thead>
                        <tr>
                            <td class="td"></td>
                            <td class="td label" style="text-align:center;">전체</td>
                            <td class="td label" style="text-align:center;">GPS입력</td>
                            <td class="td label" style="text-align:center;">활성자수</td>
                            <td class="td label" style="text-align:center; font-size:12px;">필터</td>
                        </tr>
                        </thead>
                        <tbody>
                        <tr>
                            <td class="td label">남성</td>
                            <td class="td align_right">{{statis.man_cnt | comma}}</td>
                            <td class="td align_right">{{statis.man_gps_cnt | comma}}</td>
                            <td class="td align_right">{{statis.man_active_cnt | comma}}</td>
                            <td class="td"><button class="btn" :class="filter === 'man' ? 'active' : ''" @click="changeFilter('man')"></button></td>
                        </tr>
                        <tr>
                            <td class="td label">여성</td>
                            <td class="td align_right">{{statis.woman_cnt | comma}}</td>
                            <td class="td align_right">{{statis.woman_gps_cnt | comma}}</td>
                            <td class="td align_right">{{statis.woman_active_cnt | comma}}</td>
                            <td class="td"><button class="btn" :class="filter === 'woman' ? 'active' : ''" @click="changeFilter('woman')"></button></td>
                        </tr>
                        <tr>
                            <td class="td label">전체 가입자</td>
                            <td class="td align_right">{{statis.all_reg_members_cnt | comma}}</td>
                            <td class="td align_right">{{statis.all_reg_members_gps_cnt | comma}}</td>
                            <td class="td align_right">{{statis.all_reg_members_active_cnt | comma}}</td>
                            <td class="td"><button class="btn" :class="filter === 'all_reg_members' ? 'active' : ''" @click="changeFilter('all_reg_members')"></button></td>
                        </tr>
                        <tr>
                            <td class="td label">기간 가입자</td>
                            <td class="td align_right">{{statis.period_reg_member_cnt | comma}}</td>
                            <td class="td align_right">{{statis.period_reg_member_gps_cnt | comma}}</td>
                            <td class="td align_right">{{statis.period_reg_member_active_cnt | comma}}</td>
                            <td class="td"><button class="btn" :class="filter === 'today_reg_members' ? 'active' : ''" @click="changeFilter('today_reg_members')"></button></td>
                        </tr>
                        <tr>
                            <td class="td label">전체 방문자</td>
                            <td class="td align_right">{{statis.total_visit_cnt | comma}}</td>
                            <td class="td align_right">{{statis.total_first_visit_gps_cnt + statis.total_many_visit_gps_cnt | comma}}</td>
                            <td class="td align_right">{{statis.total_first_visit_active_cnt + statis.total_many_visit_active_cnt | comma}}</td>
                            <td class="td"><button class="btn" :class="filter === 'all_visit' ? 'active' : ''" @click="changeFilter('all_visit')"></button></td>
                        </tr>
                        <tr>
                            <td class="td label">기간 방문자</td>
                            <td class="td align_right">{{statis.today_first_visit_cnt + statis.today_many_visit_cnt | comma}}</td>
                            <td class="td align_right">{{statis.today_first_visit_gps_cnt + statis.today_many_visit_gps_cnt | comma}}</td>
                            <td class="td align_right">{{statis.today_first_visit_active_cnt + statis.today_many_visit_active_cnt | comma}}</td>
                            <td class="td"><button class="btn" :class="filter === 'today_visit' ? 'active' : ''" @click="changeFilter('today_visit')"></button></td>
                        </tr>
                        <tr>
                            <td class="td label">전체 재방문</td>
                            <td class="td align_right">{{statis.total_many_visit_cnt | comma}}</td>
                            <td class="td align_right">{{statis.total_many_visit_gps_cnt | comma}}</td>
                            <td class="td align_right">{{statis.total_many_visit_active_cnt | comma}}</td>
                            <td class="td"><button class="btn" :class="filter === 'all_revisit' ? 'active' : ''" @click="changeFilter('all_revisit')"></button></td>
                        </tr>
                        <tr>
                            <td class="td label">기간 재방문</td>
                            <td class="td align_right">{{statis.today_many_visit_cnt | comma}}</td>
                            <td class="td align_right">{{statis.today_many_visit_gps_cnt | comma}}</td>
                            <td class="td align_right">{{statis.today_many_visit_active_cnt | comma}}</td>
                            <td class="td"><button class="btn" :class="filter === 'today_revisit' ? 'active' : ''" @click="changeFilter('today_revisit')"></button></td>
                        </tr>

                        <tr>
                            <td class="td label">10-</td>
                            <td class="td align_right">{{statis.age_10_minus_cnt | comma}}</td>
                            <td class="td align_right">{{statis.age_10_minus_gps_cnt | comma}}</td>
                            <td class="td align_right">{{statis.age_10_minus_active_cnt | comma}}</td>
                            <td class="td"><button class="btn" :class="filter === '10-' ? 'active' : ''" @click="changeFilter('10-')"></button></td>
                        </tr>
                        <tr>
                            <td class="td label">10+</td>
                            <td class="td align_right">{{statis.age_10_plus_cnt | comma}}</td>
                            <td class="td align_right">{{statis.age_10_plus_gps_cnt | comma}}</td>
                            <td class="td align_right">{{statis.age_10_plus_active_cnt | comma}}</td>
                            <td class="td"><button class="btn" :class="filter === '10+' ? 'active' : ''" @click="changeFilter('10+')"></button></td>
                        </tr>
                        <tr>
                            <td class="td label">20-</td>
                            <td class="td align_right">{{statis.age_20_minus_cnt | comma}}</td>
                            <td class="td align_right">{{statis.age_20_minus_gps_cnt | comma}}</td>
                            <td class="td align_right">{{statis.age_20_minus_active_cnt | comma}}</td>
                            <td class="td"><button class="btn" :class="filter === '20-' ? 'active' : ''" @click="changeFilter('20-')"></button></td>
                        </tr>
                        <tr>
                            <td class="td label">20+</td>
                            <td class="td align_right">{{statis.age_20_plus_cnt | comma}}</td>
                            <td class="td align_right">{{statis.age_20_plus_gps_cnt | comma}}</td>
                            <td class="td align_right">{{statis.age_20_plus_active_cnt | comma}}</td>
                            <td class="td"><button class="btn" :class="filter === '20+' ? 'active' : ''" @click="changeFilter('20+')"></button></td>
                        </tr>
                        <tr>
                            <td class="td label">30-</td>
                            <td class="td align_right">{{statis.age_30_minus_cnt | comma}}</td>
                            <td class="td align_right">{{statis.age_30_minus_gps_cnt | comma}}</td>
                            <td class="td align_right">{{statis.age_30_minus_active_cnt | comma}}</td>
                            <td class="td"><button class="btn" :class="filter === '30-' ? 'active' : ''" @click="changeFilter('30-')"></button></td>
                        </tr>
                        <tr>
                            <td class="td label">30+</td>
                            <td class="td align_right">{{statis.age_30_plus_cnt | comma}}</td>
                            <td class="td align_right">{{statis.age_30_plus_gps_cnt | comma}}</td>
                            <td class="td align_right">{{statis.age_30_plus_active_cnt | comma}}</td>
                            <td class="td"><button class="btn" :class="filter === '30+' ? 'active' : ''" @click="changeFilter('30+')"></button></td>
                        </tr>
                        <tr>
                            <td class="td label">40-</td>
                            <td class="td align_right">{{statis.age_40_minus_cnt | comma}}</td>
                            <td class="td align_right">{{statis.age_40_minus_gps_cnt | comma}}</td>
                            <td class="td align_right">{{statis.age_40_minus_active_cnt | comma}}</td>
                            <td class="td"><button class="btn" :class="filter === '40-' ? 'active' : ''" @click="changeFilter('40-')"></button></td>
                        </tr>
                        <tr>
                            <td class="td label">40+</td>
                            <td class="td align_right">{{statis.age_40_plus_cnt | comma}}</td>
                            <td class="td align_right">{{statis.age_40_plus_gps_cnt | comma}}</td>
                            <td class="td align_right">{{statis.age_40_plus_active_cnt | comma}}</td>
                            <td class="td"><button class="btn" :class="filter === '40+' ? 'active' : ''" @click="changeFilter('40+')"></button></td>
                        </tr>
                        <tr>
                            <td class="td label">그외</td>
                            <td class="td align_right">{{statis.etc_cnt | comma}}</td>
                            <td class="td align_right">{{statis.etc_gps_cnt | comma}}</td>
                            <td class="td align_right">{{statis.etc_active_cnt | comma}}</td>
                            <td class="td"><button class="btn" :class="filter === 'etc' ? 'active' : ''" @click="changeFilter('etc')"></button></td>
                        </tr>

                        </tbody>
                    </table>
                </div>
                <div style="width:30px; "></div>
                <div style="flex:1; position:relative; background-color: white; ">
                    <div id="statis_map" style="width:100%;height:100%; border:1px solid #dddddd;"></div>
                    <div class="title_wrap">
                        <div class="title">서울</div>
                    </div>
                </div>
                <div style="width:30px; "></div>
                <div style="flex:1; position:relative; background-color: white;">
                    <div id="statis_map2" style="width:100%;height:100%;  border:1px solid #dddddd;"></div>
                    <div class="title_wrap">
                        <div class="title">전국</div>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
    import NaverMap from '@/modules/NaverMap';
    import moment from 'moment';

    export default {
        name: "StatisMapAdmin",
        data(){
            return {
                statis : {
                    man_cnt : 0,
                    woman_cnt : 0,
                    man_gps_cnt : 0,
                    woman_gps_cnt : 0,
                    man_active_cnt : 0,
                    woman_active_cnt : 0,
                    period_reg_member_cnt : 0,
                    all_reg_members_cnt : 0,
                    period_reg_member_gps_cnt : 0,
                    all_reg_members_gps_cnt : 0,
                    period_reg_member_active_cnt : 0,
                    all_reg_members_active_cnt : 0,
                    total_first_visit_cnt : 0,
                    total_many_visit_cnt : 0,
                    total_first_visit_gps_cnt : 0,
                    total_many_visit_gps_cnt : 0,
                    total_first_visit_active_cnt : 0,
                    total_many_visit_active_cnt : 0,
                    today_first_visit_cnt : 0,
                    today_many_visit_cnt : 0,
                    today_first_visit_gps_cnt : 0,
                    today_many_visit_gps_cnt : 0,
                    today_first_visit_active_cnt : 0,
                    today_many_visit_active_cnt : 0,

                    total_visit_cnt : 0,

                    age_10_minus_cnt : 0,
                    age_10_minus_gps_cnt : 0,
                    age_10_minus_active_cnt : 0,
                    age_10_plus_cnt : 0,
                    age_10_plus_gps_cnt : 0,
                    age_10_plus_active_cnt : 0,
                    age_20_minus_cnt : 0,
                    age_20_minus_gps_cnt : 0,
                    age_20_minus_active_cnt : 0,
                    age_20_plus_cnt : 0,
                    age_20_plus_gps_cnt : 0,
                    age_20_plus_active_cnt : 0,
                    age_30_minus_cnt : 0,
                    age_30_minus_gps_cnt : 0,
                    age_30_minus_active_cnt : 0,
                    age_30_plus_cnt : 0,
                    age_30_plus_gps_cnt : 0,
                    age_30_plus_active_cnt : 0,
                    age_40_minus_cnt : 0,
                    age_40_minus_gps_cnt : 0,
                    age_40_minus_active_cnt : 0,
                    age_40_plus_cnt : 0,
                    age_40_plus_gps_cnt : 0,
                    age_40_plus_active_cnt : 0,
                    etc_cnt : 0,
                    etc_gps_cnt : 0,
                    etc_active_cnt : 0,

                },
                filter : '',
                naverMap1 : null,
                naverMap2: null,
                startDate : '',
                endDate : '',
            }
        },
        methods : {
            async getStatis(){
                const res = await this.$Axios.get('/api/statis/map');
                this.statis = res.data;
                this.changeFilter('today_reg_members');
            },
            async changeFilter(filter){
                this.filter = filter;
                const parameters = {filter : filter, startDate : this.startDate, endDate : this.endDate};
                const res = await this.$Axios.get('/api/statis/map/filter', {params : parameters});
                const gpsData = res.data.gpsData;

                this.naverMap1.removeClustering();
                this.naverMap1.addClustering(gpsData);
                this.naverMap2.removeClustering();
                this.naverMap2.addClustering(gpsData);
            },
            async setStatisPeriodDate(startDate, endDate){
                this.startDate = startDate;
                this.endDate = endDate;

                const parameters = {};
                parameters.startDate = startDate;
                parameters.endDate = endDate;

                const res = await this.$Axios.get('/api/statis/map/period', {params : parameters});
                console.log(res.data);
                this.statis.period_reg_member_cnt = res.data.period_reg_member_cnt;
                this.statis.period_reg_member_gps_cnt = res.data.period_reg_member_gps_cnt;
                this.statis.period_reg_member_active_cnt = res.data.period_reg_member_active_cnt;
                this.statis.today_first_visit_cnt = res.data.period_first_visit_cnt;
                this.statis.today_many_visit_cnt = res.data.period_many_visit_cnt;
                this.statis.today_first_visit_gps_cnt = res.data.period_first_visit_gps_cnt;
                this.statis.today_many_visit_gps_cnt = res.data.period_many_visit_gps_cnt;
                this.statis.today_first_visit_active_cnt = res.data.period_first_visit_active_cnt;
                this.statis.today_many_visit_active_cnt = res.data.period_many_visit_active_cnt;

                this.changeFilter(this.filter);
                // this. res.data.

            }
        },
        mounted(){
            setTimeout(() => {
                this.naverMap1 = new NaverMap();
                this.naverMap2 = new NaverMap();
                const options = {
                    zoom : 9
                };

                //서울
                this.naverMap1.initMap('statis_map', 37.5492850, 126.988923, options);
                // this.naverMap1.addClustering();

                const options2 = {
                    zoom : 7
                };

                //전국
                this.naverMap2.initMap('statis_map2', 36.6, 127.9, options2);
                // this.naverMap2.addClustering();

                this.getStatis();
            }, 0)

        },
        created(){
            const today = moment().format('YYYY-MM-DD');
            this.startDate = today;
            this.endDate = today;

            window.setStatisPeriodDate = this.setStatisPeriodDate;
        }
    }
</script>

<style scoped>

    .tb{
        width: 100%;
        border: 1px solid #dddddd;
        border-collapse: collapse;
        border-radius:5px;
    }
    .td{  border: 1px solid #dddddd; padding:10px 5px;font-family: 'Malgun Gothic', san-serif; font-size:12px;}
    .td:nth-of-type(1){text-align:center;}
    .td:nth-of-type(5){padding:0px;font-size:0px;}
    .label { font-weight:bold;}
    .align_right{text-align:right;}
    .btn{width:100%;height:32px; display:inline-block; border:0px; cursor:pointer;}
    .btn.active{background-color: #6544d9}
    .btn:hover{background-color:#B5A9D9;}
    .title_wrap{position:absolute; text-align:center;  top:0px; left:0px; width:100%;}
    .title{background-color: rgba(255, 255, 255, 0.8); font-size:18px; padding:10px; text-align:center;  font-weight:bold;  border:1px solid #dddddd; }
</style>